export const HeroImage = ({receiverName, receiverProfilePicture, receiverUrl, linked}) =>
  <div className='donations-new-hero-image text-xl'>
    <img src={receiverProfilePicture}/>
    {linked ? <a className='text-3xl' href={receiverUrl}>{receiverName}</a> : <span>{receiverName}</span>}
  </div>
